import React from "react";
import clsx from "clsx";
import { isUndefined } from "lodash";
import LinkedAccountTypeaheadRenderOption from "../../../../../../../../components/LinkedAccountTypeaheadRenderOption";
import { Typeahead } from "@merge-api/merge-javascript-shared";
import { APITesterLinkedAccount } from "../../../../../../../../models/Entities";

type LinkedAccountSelectProps = {
  className?: string;
  linkedAccount?: APITesterLinkedAccount | null;
  setLinkedAccount: React.Dispatch<React.SetStateAction<APITesterLinkedAccount | undefined>>;
  linkedAccounts?: APITesterLinkedAccount[];
  onSearchChange: (search: string) => void;
};

const LinkedAccountSelect = ({
  className,
  linkedAccount,
  setLinkedAccount,
  linkedAccounts,
  onSearchChange,
}: LinkedAccountSelectProps) => {
  return (
    <div className={clsx("", className)}>
      <Typeahead
        className="bg-white"
        popperMaxHeight={428}
        options={linkedAccounts || []}
        areOptionsEqual={(option, value) => option.id === value.id}
        value={linkedAccount}
        getOptionLabel={(linkedAccount) => linkedAccount.end_user.organization_name}
        getOptionKey={(linkedAccount) => linkedAccount.id}
        placeholder="Search for integration or Linked Account..."
        onChange={(
          _: any,
          linkedAccount: APITesterLinkedAccount | null | APITesterLinkedAccount[],
        ) => {
          !Array.isArray(linkedAccount) && setLinkedAccount(linkedAccount || undefined);
        }}
        onInputChange={(_, value, reason) => reason !== "reset" && onSearchChange(value)}
        filterOptions={(options) => options}
        loading={isUndefined(linkedAccounts)}
        noOptionsText="No Linked Accounts. Check out Mock Sandbox to test our API"
        renderOption={(linkedAccount) => (
          <LinkedAccountTypeaheadRenderOption linkedAccount={linkedAccount} />
        )}
      />
    </div>
  );
};

export default LinkedAccountSelect;
